// Constants for swipe interface configuration

export const SWIPE_THRESHOLDS = {
  DISTANCE: 120,
  VELOCITY: 0.5,
  SNAP_BACK: 80,
} as const;

export const ANIMATION_CONFIG = {
  DURATION: 300,
  EASING: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
  EXIT_VELOCITY: 1000,
  ROTATION_FACTOR: 0.15,
  SCALE_FACTOR: 0.95,
} as const;

export const GESTURE_CONFIG = {
  MIN_VELOCITY: 0.2,
  VELOCITY_SAMPLES: 5,
  POINTER_TOLERANCE: 10,
} as const;

export const CARD_STACK_CONFIG = {
  MAX_VISIBLE: 3,
  SCALE_FACTOR: 0.05,
  OPACITY_FACTOR: 0.3,
  Z_OFFSET: 1,
} as const;